import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { AIMessagesBanner } from 'components/AI/AIBanner/AIMessagesBanner/AIMessagesBanner';
import { AIFilesBanner } from 'components/AI/AIBanner/AIFilesBanner/AIFilesBanner';
import { Stack } from '@mui/material';

export interface AIFlaggedBannerProps {
  /**
   * Type of banner to display
   */
  type: 'message' | 'file';
}

/**
 * AIFlaggedBanner component that conditionally renders based on feature flags
 *
 * @param props - Component props
 * @returns React component or null if feature flag is disabled
 */
export const AIFlaggedBanner: React.FC<AIFlaggedBannerProps> = ({ type }) => {
  const { enableAiComposeButton } = useFlags();

  // Return null if the feature flag is disabled
  if (!enableAiComposeButton) {
    return null;
  }

  // Return the appropriate banner based on type
  const banner = type === 'message' ? <AIMessagesBanner /> : <AIFilesBanner />;

  return <Stack sx={{ padding: '1.6rem 2.3rem' }}>{banner}</Stack>;
};

export default AIFlaggedBanner;
